import _defineProperty from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { MOST_NEGATIVE_SINGLE_FLOAT, MOST_POSITIVE_SINGLE_FLOAT } from '../constants';
import { computeBufferSize } from '../helpers/compute-buffer-size';
import { copyFromChannel } from '../helpers/copy-from-channel';
import { copyToChannel } from '../helpers/copy-to-channel';
import { createAudioWorkletProcessor } from '../helpers/create-audio-worklet-processor';
import { createNestedArrays } from '../helpers/create-nested-arrays';
import { ReadOnlyMap } from '../read-only-map';
export var createNativeAudioWorkletNodeFakerFactory = function createNativeAudioWorkletNodeFakerFactory(connectMultipleOutputs, createIndexSizeError, createInvalidStateError, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, createNativeScriptProcessorNode, createNotSupportedError, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getActiveAudioWorkletNodeInputs, monitorConnections) {
  return function (nativeContext, baseLatency, processorConstructor, options) {
    if (options.numberOfInputs === 0 && options.numberOfOutputs === 0) {
      throw createNotSupportedError();
    }

    var outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount); // @todo Check if any of the channelCount values is greater than the implementation's maximum number of channels.

    if (outputChannelCount.some(function (channelCount) {
      return channelCount < 1;
    })) {
      throw createNotSupportedError();
    }

    if (outputChannelCount.length !== options.numberOfOutputs) {
      throw createIndexSizeError();
    } // Bug #61: This is not part of the standard but required for the faker to work.


    if (options.channelCountMode !== 'explicit') {
      throw createNotSupportedError();
    }

    var numberOfInputChannels = options.channelCount * options.numberOfInputs;
    var numberOfOutputChannels = outputChannelCount.reduce(function (sum, value) {
      return sum + value;
    }, 0);
    var numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length; // Bug #61: This is not part of the standard but required for the faker to work.

    if (numberOfInputChannels + numberOfParameters > 6 || numberOfOutputChannels > 6) {
      throw createNotSupportedError();
    }

    var messageChannel = new MessageChannel();
    var gainNodes = [];
    var inputChannelSplitterNodes = [];

    for (var i = 0; i < options.numberOfInputs; i += 1) {
      gainNodes.push(createNativeGainNode(nativeContext, {
        channelCount: options.channelCount,
        channelCountMode: options.channelCountMode,
        channelInterpretation: options.channelInterpretation,
        gain: 1
      }));
      inputChannelSplitterNodes.push(createNativeChannelSplitterNode(nativeContext, {
        channelCount: options.channelCount,
        channelCountMode: 'explicit',
        channelInterpretation: 'discrete',
        numberOfOutputs: options.channelCount
      }));
    }

    var constantSourceNodes = [];

    if (processorConstructor.parameterDescriptors !== undefined) {
      var _iterator = _createForOfIteratorHelper(processorConstructor.parameterDescriptors),
          _step;

      try {
        var _loop = function _loop() {
          var _step$value = _step.value,
              defaultValue = _step$value.defaultValue,
              maxValue = _step$value.maxValue,
              minValue = _step$value.minValue,
              name = _step$value.name;
          var constantSourceNode = createNativeConstantSourceNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            offset: options.parameterData[name] !== undefined ? options.parameterData[name] : defaultValue === undefined ? 0 : defaultValue
          });
          Object.defineProperties(constantSourceNode.offset, {
            defaultValue: {
              get: function get() {
                return defaultValue === undefined ? 0 : defaultValue;
              }
            },
            maxValue: {
              get: function get() {
                return maxValue === undefined ? MOST_POSITIVE_SINGLE_FLOAT : maxValue;
              }
            },
            minValue: {
              get: function get() {
                return minValue === undefined ? MOST_NEGATIVE_SINGLE_FLOAT : minValue;
              }
            }
          });
          constantSourceNodes.push(constantSourceNode);
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    var inputChannelMergerNode = createNativeChannelMergerNode(nativeContext, {
      channelCount: 1,
      channelCountMode: 'explicit',
      channelInterpretation: 'speakers',
      numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
    });
    var bufferSize = computeBufferSize(baseLatency, nativeContext.sampleRate);
    var scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, bufferSize, numberOfInputChannels + numberOfParameters, // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.
    Math.max(1, numberOfOutputChannels));
    var outputChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
      channelCount: Math.max(1, numberOfOutputChannels),
      channelCountMode: 'explicit',
      channelInterpretation: 'discrete',
      numberOfOutputs: Math.max(1, numberOfOutputChannels)
    });
    var outputChannelMergerNodes = [];

    for (var _i = 0; _i < options.numberOfOutputs; _i += 1) {
      outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeContext, {
        channelCount: 1,
        channelCountMode: 'explicit',
        channelInterpretation: 'speakers',
        numberOfInputs: outputChannelCount[_i]
      }));
    }

    for (var _i2 = 0; _i2 < options.numberOfInputs; _i2 += 1) {
      gainNodes[_i2].connect(inputChannelSplitterNodes[_i2]);

      for (var j = 0; j < options.channelCount; j += 1) {
        inputChannelSplitterNodes[_i2].connect(inputChannelMergerNode, j, _i2 * options.channelCount + j);
      }
    }

    var parameterMap = new ReadOnlyMap(processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.map(function (_ref, index) {
      var name = _ref.name;
      var constantSourceNode = constantSourceNodes[index];
      constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
      constantSourceNode.start(0);
      return [name, constantSourceNode.offset];
    }));
    inputChannelMergerNode.connect(scriptProcessorNode);
    var channelInterpretation = options.channelInterpretation;
    var onprocessorerror = null; // Bug #87: Expose at least one output to make this node connectable.

    var outputAudioNodes = options.numberOfOutputs === 0 ? [scriptProcessorNode] : outputChannelMergerNodes;
    var nativeAudioWorkletNodeFaker = {
      get bufferSize() {
        return bufferSize;
      },

      get channelCount() {
        return options.channelCount;
      },

      set channelCount(_) {
        // Bug #61: This is not part of the standard but required for the faker to work.
        throw createInvalidStateError();
      },

      get channelCountMode() {
        return options.channelCountMode;
      },

      set channelCountMode(_) {
        // Bug #61: This is not part of the standard but required for the faker to work.
        throw createInvalidStateError();
      },

      get channelInterpretation() {
        return channelInterpretation;
      },

      set channelInterpretation(value) {
        var _iterator2 = _createForOfIteratorHelper(gainNodes),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var gainNode = _step2.value;
            gainNode.channelInterpretation = value;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        channelInterpretation = value;
      },

      get context() {
        return scriptProcessorNode.context;
      },

      get inputs() {
        return gainNodes;
      },

      get numberOfInputs() {
        return options.numberOfInputs;
      },

      get numberOfOutputs() {
        return options.numberOfOutputs;
      },

      get onprocessorerror() {
        return onprocessorerror;
      },

      set onprocessorerror(value) {
        if (typeof onprocessorerror === 'function') {
          nativeAudioWorkletNodeFaker.removeEventListener('processorerror', onprocessorerror);
        }

        onprocessorerror = typeof value === 'function' ? value : null;

        if (typeof onprocessorerror === 'function') {
          nativeAudioWorkletNodeFaker.addEventListener('processorerror', onprocessorerror);
        }
      },

      get parameters() {
        return parameterMap;
      },

      get port() {
        return messageChannel.port2;
      },

      addEventListener: function addEventListener() {
        return scriptProcessorNode.addEventListener(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
      },
      connect: connectMultipleOutputs.bind(null, outputAudioNodes),
      disconnect: disconnectMultipleOutputs.bind(null, outputAudioNodes),
      dispatchEvent: function dispatchEvent() {
        return scriptProcessorNode.dispatchEvent(arguments.length <= 0 ? undefined : arguments[0]);
      },
      removeEventListener: function removeEventListener() {
        return scriptProcessorNode.removeEventListener(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
      }
    };
    var patchedEventListeners = new Map();

    messageChannel.port1.addEventListener = function (addEventListener) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (args[0] === 'message') {
          var unpatchedEventListener = typeof args[1] === 'function' ? args[1] : typeof args[1] === 'object' && args[1] !== null && typeof args[1].handleEvent === 'function' ? args[1].handleEvent : null;

          if (unpatchedEventListener !== null) {
            var patchedEventListener = patchedEventListeners.get(args[1]);

            if (patchedEventListener !== undefined) {
              args[1] = patchedEventListener;
            } else {
              args[1] = function (event) {
                exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, function () {
                  return unpatchedEventListener(event);
                });
              };

              patchedEventListeners.set(unpatchedEventListener, args[1]);
            }
          }
        }

        return addEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
      };
    }(messageChannel.port1.addEventListener);

    messageChannel.port1.removeEventListener = function (removeEventListener) {
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (args[0] === 'message') {
          var patchedEventListener = patchedEventListeners.get(args[1]);

          if (patchedEventListener !== undefined) {
            patchedEventListeners.delete(args[1]);
            args[1] = patchedEventListener;
          }
        }

        return removeEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
      };
    }(messageChannel.port1.removeEventListener);

    var onmessage = null;
    Object.defineProperty(messageChannel.port1, 'onmessage', {
      get: function get() {
        return onmessage;
      },
      set: function set(value) {
        if (typeof onmessage === 'function') {
          messageChannel.port1.removeEventListener('message', onmessage);
        }

        onmessage = typeof value === 'function' ? value : null;

        if (typeof onmessage === 'function') {
          messageChannel.port1.addEventListener('message', onmessage);
          messageChannel.port1.start();
        }
      }
    });
    processorConstructor.prototype.port = messageChannel.port1;
    var audioWorkletProcessor = null;
    var audioWorkletProcessorPromise = createAudioWorkletProcessor(nativeContext, nativeAudioWorkletNodeFaker, processorConstructor, options);
    audioWorkletProcessorPromise.then(function (dWrkltPrcssr) {
      return audioWorkletProcessor = dWrkltPrcssr;
    });
    var inputs = createNestedArrays(options.numberOfInputs, options.channelCount);
    var outputs = createNestedArrays(options.numberOfOutputs, outputChannelCount);
    var parameters = processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.reduce(function (prmtrs, _ref2) {
      var name = _ref2.name;
      return _objectSpread({}, prmtrs, _defineProperty({}, name, new Float32Array(128)));
    }, {});
    var isActive = true;

    var disconnectOutputsGraph = function disconnectOutputsGraph() {
      if (options.numberOfOutputs > 0) {
        scriptProcessorNode.disconnect(outputChannelSplitterNode);
      }

      for (var _i3 = 0, outputChannelSplitterNodeOutput = 0; _i3 < options.numberOfOutputs; _i3 += 1) {
        var outputChannelMergerNode = outputChannelMergerNodes[_i3];

        for (var _j = 0; _j < outputChannelCount[_i3]; _j += 1) {
          outputChannelSplitterNode.disconnect(outputChannelMergerNode, outputChannelSplitterNodeOutput + _j, _j);
        }

        outputChannelSplitterNodeOutput += outputChannelCount[_i3];
      }
    };

    var activeInputIndexes = new Map(); // tslint:disable-next-line:deprecation

    scriptProcessorNode.onaudioprocess = function (_ref3) {
      var inputBuffer = _ref3.inputBuffer,
          outputBuffer = _ref3.outputBuffer;

      if (audioWorkletProcessor !== null) {
        (function () {
          var activeInputs = getActiveAudioWorkletNodeInputs(nativeAudioWorkletNodeFaker);

          var _loop2 = function _loop2(_i4) {
            for (var _j2 = 0; _j2 < options.numberOfInputs; _j2 += 1) {
              for (var k = 0; k < options.channelCount; k += 1) {
                copyFromChannel(inputBuffer, inputs[_j2], k, k, _i4);
              }
            }

            if (processorConstructor.parameterDescriptors !== undefined) {
              processorConstructor.parameterDescriptors.forEach(function (_ref4, index) {
                var name = _ref4.name;
                copyFromChannel(inputBuffer, parameters, name, numberOfInputChannels + index, _i4);
              });
            }

            for (var _j3 = 0; _j3 < options.numberOfInputs; _j3 += 1) {
              for (var _k = 0; _k < outputChannelCount[_j3]; _k += 1) {
                // The byteLength will be 0 when the ArrayBuffer was transferred.
                if (outputs[_j3][_k].byteLength === 0) {
                  outputs[_j3][_k] = new Float32Array(128);
                }
              }
            }

            try {
              var potentiallyEmptyInputs = inputs.map(function (input, index) {
                var activeInput = activeInputs[index];

                if (activeInput.size > 0) {
                  activeInputIndexes.set(index, bufferSize / 128);
                  return input;
                }

                var count = activeInputIndexes.get(index);

                if (count === undefined) {
                  return [];
                }

                if (input.every(function (channelData) {
                  return channelData.every(function (sample) {
                    return sample === 0;
                  });
                })) {
                  if (count === 1) {
                    activeInputIndexes.delete(index);
                  } else {
                    activeInputIndexes.set(index, count - 1);
                  }
                }

                return input;
              });
              var activeSourceFlag = exposeCurrentFrameAndCurrentTime(nativeContext.currentTime + _i4 / nativeContext.sampleRate, nativeContext.sampleRate, function () {
                return audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters);
              });
              isActive = activeSourceFlag;

              for (var _j4 = 0, outputChannelSplitterNodeOutput = 0; _j4 < options.numberOfOutputs; _j4 += 1) {
                for (var _k2 = 0; _k2 < outputChannelCount[_j4]; _k2 += 1) {
                  copyToChannel(outputBuffer, outputs[_j4], _k2, outputChannelSplitterNodeOutput + _k2, _i4);
                }

                outputChannelSplitterNodeOutput += outputChannelCount[_j4];
              }
            } catch (error) {
              isActive = false;
              nativeAudioWorkletNodeFaker.dispatchEvent(new ErrorEvent('processorerror', {
                colno: error.colno,
                filename: error.filename,
                lineno: error.lineno,
                message: error.message
              }));
            }

            if (!isActive) {
              for (var _j5 = 0; _j5 < options.numberOfInputs; _j5 += 1) {
                gainNodes[_j5].disconnect(inputChannelSplitterNodes[_j5]);

                for (var _k3 = 0; _k3 < options.channelCount; _k3 += 1) {
                  inputChannelSplitterNodes[_i4].disconnect(inputChannelMergerNode, _k3, _j5 * options.channelCount + _k3);
                }
              }

              if (processorConstructor.parameterDescriptors !== undefined) {
                var length = processorConstructor.parameterDescriptors.length;

                for (var _j6 = 0; _j6 < length; _j6 += 1) {
                  var constantSourceNode = constantSourceNodes[_j6];
                  constantSourceNode.disconnect(inputChannelMergerNode, 0, numberOfInputChannels + _j6);
                  constantSourceNode.stop();
                }
              }

              inputChannelMergerNode.disconnect(scriptProcessorNode);
              scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation

              if (isConnected) {
                disconnectOutputsGraph();
              } else {
                disconnectFakeGraph();
              }

              return "break";
            }
          };

          for (var _i4 = 0; _i4 < bufferSize; _i4 += 128) {
            var _ret = _loop2(_i4);

            if (_ret === "break") break;
          }
        })();
      }
    };

    var isConnected = false; // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.

    var nativeGainNode = createNativeGainNode(nativeContext, {
      channelCount: 1,
      channelCountMode: 'explicit',
      channelInterpretation: 'discrete',
      gain: 0
    });

    var connectFakeGraph = function connectFakeGraph() {
      return scriptProcessorNode.connect(nativeGainNode).connect(nativeContext.destination);
    };

    var disconnectFakeGraph = function disconnectFakeGraph() {
      scriptProcessorNode.disconnect(nativeGainNode);
      nativeGainNode.disconnect();
    };

    var whenConnected = function whenConnected() {
      if (isActive) {
        disconnectFakeGraph();

        if (options.numberOfOutputs > 0) {
          scriptProcessorNode.connect(outputChannelSplitterNode);
        }

        for (var _i5 = 0, outputChannelSplitterNodeOutput = 0; _i5 < options.numberOfOutputs; _i5 += 1) {
          var outputChannelMergerNode = outputChannelMergerNodes[_i5];

          for (var _j7 = 0; _j7 < outputChannelCount[_i5]; _j7 += 1) {
            outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + _j7, _j7);
          }

          outputChannelSplitterNodeOutput += outputChannelCount[_i5];
        }
      }

      isConnected = true;
    };

    var whenDisconnected = function whenDisconnected() {
      if (isActive) {
        connectFakeGraph();
        disconnectOutputsGraph();
      }

      isConnected = false;
    };

    connectFakeGraph();
    return monitorConnections(nativeAudioWorkletNodeFaker, whenConnected, whenDisconnected);
  };
};